import BotIcon from '@cp/src/assets/icons/BotIcon';
import { AuditorType } from './components/auditEnums';
import { STATUS_DISPLAY_MAP, AUDIT_STATUS } from './const';
import { TagColors } from '@navi/web-ui/lib/primitives/Tag/types';
import CallingAgentIcon from '@cp/src/assets/icons/CallingAgentIcon';
import TlAuditIcon from '@cp/src/assets/icons/TlAuditIcon';
import { AuditOption } from './interface';
import { IOption } from '@cp/src/components/AutocompleteDropdown/interfaces';

export interface StatusConfig {
  label: string;
  suffix?: string;
  bgColor: string;
  textColor: string;
  suffixColor?: string;
}

export const getStatusDisplay = (status: string): { label: string; suffix?: string } => {
  return STATUS_DISPLAY_MAP[status as AUDIT_STATUS] || { label: status };
};

export const AUDIT_STATUS_COLORS: Record<string, TagColors> = {
  VIOLATION: 'red',
  CLEARED: 'green',
  PENDING: 'orange'
};

export const getAuditStatusColor = (status: string): TagColors => {
  const lowerStatus = status?.toLowerCase();
  if (lowerStatus?.includes('violation')) return AUDIT_STATUS_COLORS.VIOLATION;
  if (lowerStatus?.includes('cleared')) return AUDIT_STATUS_COLORS.CLEARED;
  return AUDIT_STATUS_COLORS.PENDING;
};

export const STATUS_CONFIG: Record<string, StatusConfig> = {
  PENDING: {
    label: 'Pending',
    bgColor: 'var(--navi-color-yellow-bg)',
    textColor: 'var(--navi-color-yellow-dark)'
  },
  AGENT_CLEARED: {
    label: 'Cleared',
    bgColor: 'var(--navi-color-green-bg)',
    textColor: 'var(--navi-color-green-base)'
  },
  AGENT_VIOLATION: {
    label: 'Violation',
    bgColor: 'var(--navi-color-red-bg)',
    textColor: 'var(--navi-color-red-base)'
  },
  TL_CONFIRMED_CLEARED: {
    label: 'Cleared',
    suffix: '(Confirmed)',
    bgColor: 'var(--navi-color-green-bg)',
    textColor: 'var(--navi-color-green-base)',
    suffixColor: 'var(--navi-color-gray-c3)'
  },
  TL_CONFIRMED_VIOLATION: {
    label: 'Violation',
    suffix: '(Confirmed)',
    bgColor: 'var(--navi-color-red-bg)',
    textColor: 'var(--navi-color-red-base)',
    suffixColor: 'var(--navi-color-gray-c3)'
  },
  TL_OVERRULED_TO_CLEARED: {
    label: 'Cleared',
    suffix: '(Updated)',
    bgColor: 'var(--navi-color-green-bg)',
    textColor: 'var(--navi-color-green-base)',
    suffixColor: 'var(--navi-color-gray-c3)'
  },
  TL_OVERRULED_TO_VIOLATION: {
    label: 'Violation',
    suffix: '(Updated)',
    bgColor: 'var(--navi-color-red-bg)',
    textColor: 'var(--navi-color-red-base)',
    suffixColor: 'var(--navi-color-gray-c3)'
  },
  TL_DIRECT_CLEARED: {
    label: 'Cleared',
    suffix: '(Reviewed)',
    bgColor: 'var(--navi-color-green-bg)',
    textColor: 'var(--navi-color-green-base)',
    suffixColor: 'var(--navi-color-gray-c3)'
  },
  TL_DIRECT_VIOLATION: {
    label: 'Violation',
    suffix: '(Reviewed)',
    bgColor: 'var(--navi-color-red-bg)',
    textColor: 'var(--navi-color-red-base)',
    suffixColor: 'var(--navi-color-gray-c3)'
  }
};

export const SOURCE_ICON_MAP: Record<string, React.ReactNode> = {
  [AuditorType.DS]: <BotIcon width={20} height={20} />,
  [AuditorType.QC_AGENT]: <CallingAgentIcon width={20} height={20} />,
  [AuditorType.QC_TEAM_LEAD]: <TlAuditIcon width={20} height={20} />
};

export const AUDIT_ICON_MAP: Record<string, React.ReactNode> = {
  DS: <BotIcon />,
  QC_AGENT: <CallingAgentIcon />,
  QC_TEAM_LEAD: <TlAuditIcon />
};

export const getRadioOptions = (options: AuditOption[]) => {
  return options.map(opt => ({
    id: String(opt.option_id),
    label: opt.option_text,
    value: String(opt.option_id)
  }));
};

export const getDropdownOptions = (options: AuditOption[]): IOption[] => {
  return options.map(opt => ({
    value: String(opt.option_id),
    label: opt.option_text
  }));
};
